module.exports = __webpack_public_path__ + "static/media/avatar-0.d7dc77f8.svg";